interface FooterProps {
  constantsVersion: string;
  constantsVerifiedAt: string;
}

export function Footer({ constantsVersion, constantsVerifiedAt }: FooterProps) {
  return (
    <footer
      class="border-t border-card-border bg-cream px-4 py-2 text-center"
      role="contentinfo"
    >
      <p class="text-xs text-body/70 leading-relaxed">
        Educational tool only · Not tax advice · Verify with CRA before contributing
      </p>
      <p class="text-xs text-body/70 mt-0.5">
        HBF · Constants {constantsVersion} · Verified {constantsVerifiedAt} ·{' '}
        <a
          href="/settings"
          class="underline hover:text-hudson-navy focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
        >
          Settings
        </a>
        {' · '}
        <a
          href="/about"
          class="underline hover:text-hudson-navy focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
        >
          About →
        </a>
      </p>
    </footer>
  );
}
